/* eslint-disable boundaries/element-types */
import type { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import type { MatDialogRef } from '@angular/material/dialog';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@app/components/modals/confirm-dialog/confirm-dialog.component';
import { MessageDialogComponent } from '@app/components/modals/message-dialog/message-dialog.component';
import type { IModalData, IModalMessageData } from '@app/types/modal-data';
import type { IModalFormData } from '../../types/modal-form-data';

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    private dialog = inject(MatDialog);

    confirm(
        data: IModalData, //force use of type
        config: MatDialogConfig = this.getDefaultConfirmDialogConfig(),
    ): MatDialogRef<unknown> {
        config.data = data;
        return this.dialog.open<ConfirmDialogComponent, IModalData>(
            ConfirmDialogComponent as ComponentType<ConfirmDialogComponent>,
            config,
        );
    }

    show(
        component: ComponentType<unknown>,
        config: MatDialogConfig = new MatDialogConfig(),
    ): MatDialogRef<unknown> {
        return this.dialog.open(component, config);
    }
    showForm(
        component: ComponentType<unknown>,
        data: IModalFormData,
        config: MatDialogConfig = new MatDialogConfig(),
    ): MatDialogRef<unknown> {
        config.data = data;
        return this.dialog.open(component, config);
    }
    showMessage(
        messageData: IModalMessageData,
        config: MatDialogConfig = new MatDialogConfig(),
    ) {
        config.data = messageData;
        return this.dialog.open<MessageDialogComponent>(
            MessageDialogComponent as ComponentType<MessageDialogComponent>,
            config,
        );
    }

    close() {
        this.dialog.closeAll();
    }

    private getDefaultConfirmDialogConfig(): MatDialogConfig {
        return {
            width: '400px',
            disableClose: true,
            panelClass: 'confirm-dialog',
        };
    }
}
